import {UPDATE_ADVERTISEMENT_IDENTIFIER} from "./mutation-types";

export  default {
    [UPDATE_ADVERTISEMENT_IDENTIFIER](state, payload) {
        state.identifier = payload;
    }
}
